import styled from 'styled-components';

export const ServicesSection = styled.section`
  padding: 5rem 0;
  background: white;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  color: #1e293b;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.125rem;
  text-align: center;
  color: #64748b;
  margin-bottom: 4rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-bottom: 3rem;
  }
`;

export const ServiceCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px #19727833;
    border-color: #197278;
  }
`;

export const ServiceIcon = styled.div`
  font-size: 3rem;
  color: #197278;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
`;

export const ServiceTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  line-height: 1.3;
`;

export const ServiceDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #475569;
  flex-grow: 1;
`;

export const CTASection = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 3rem;
  border-radius: 16px;
  text-align: center;
  border: 1px solid #e2e8f0;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const CTATitle = styled.h3`
  font-size: 1.75rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const CTADescription = styled.p`
  font-size: 1.125rem;
  line-height: 1.6;
  color: #475569;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const CTAButton = styled.button`
  background: #197278;
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 8px;
  font-size: 1.125rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px #19727833;

  &:hover {
    background: #145A5A;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px #19727855;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
  }
`; 